"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Swiper = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var SwiperPlug = __importStar(require("swiper/react"));
var core_1 = __importStar(require("swiper/core"));
var storybook_1 = require("@eyecons/storybook");
core_1.default.use([core_1.Navigation, core_1.Pagination]);
var Swiper = function (_a) {
    var className = _a.className, spaceBetween = _a.spaceBetween, slidesPerView = _a.slidesPerView, children = _a.children, breakpoints = _a.breakpoints, pagination = _a.pagination, modules = _a.modules;
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-layouts-swiper', className) },
        react_1.default.createElement("div", { className: 'storybook-layouts-swiper-next' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'chevron-down' })),
        react_1.default.createElement(SwiperPlug.Swiper, { spaceBetween: spaceBetween, slidesPerView: slidesPerView, navigation: {
                nextEl: '.storybook-layouts-swiper-next',
                prevEl: '.storybook-layouts-swiper-prev',
            }, breakpoints: breakpoints }, children),
        react_1.default.createElement("div", { className: 'storybook-layouts-swiper-prev' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'chevron-down' })));
};
exports.Swiper = Swiper;
exports.Swiper.propTypes = {
    /**
     * Add custom classname
     */
    className: prop_types_1.default.string,
    /**
     * The HTML inside of the Item
     */
    children: prop_types_1.default.any,
    /**
     * Space between the swiper slides
     */
    spaceBetween: prop_types_1.default.number,
    // /**
    //  * Space between the swiper slides
    //  */
    // slidesPerView: PropTypes.number
};
exports.Swiper.defaultProps = {
    breakpoints: {
        "0": {
            "slidesPerView": 1.5,
        },
        "768": {
            "slidesPerView": 3.5,
        }
    }
};
